import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { Icon } from "@/lib/icons";
import GiveModal from "@/components/giving/GiveModal";

const money = (c) => `$${((c || 0) / 100).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
const oneLine = (s) => (s || "").replace(/<[^>]+>/g, "").slice(0, 64);

// Dashboard "Ways to give" card — up to 3 Live campaigns/funds, each with a Give
// button. Progress + totals appear only where Show-progress is on. General Fund
// shows as "Give to RCA" with no numbers. Hidden entirely when nothing is Live.
export default function WaysToGive({ prefill, onSeeAll }) {
  const [items, setItems] = useState(null);
  const [give, setGive] = useState(null);
  useEffect(() => { api.get("/giving/campaigns").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  if (!items || items.length === 0) return null;
  const top = items.slice(0, 3);
  return (
    <div className="bg-cream border border-ink/15 rounded-xl p-5" data-testid="ways-to-give">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-zilla text-xl font-semibold">Ways to give</h2>
        {items.length > 3 && onSeeAll && (
          <button data-testid="ways-see-all" onClick={onSeeAll} className="text-[13px] font-semibold text-maroon hover:underline">See all</button>
        )}
      </div>
      <div className="space-y-3">
        {top.map((c) => {
          const showProg = c.show_progress && !c.is_default && c.raised_cents != null;
          const pct = c.goal_cents ? Math.min(100, Math.round((c.raised_cents / c.goal_cents) * 100)) : 100;
          return (
            <div key={c.campaign_id} data-testid={`ways-item-${c.campaign_id}`} className="flex items-center gap-3">
              {c.cover_image
                ? <img src={c.cover_image} alt="" className="w-12 h-12 rounded-lg object-cover shrink-0" />
                : <div className="w-12 h-12 rounded-lg bg-dark-olive/10 flex items-center justify-center shrink-0"><Icon name="HeartHandshake" className="w-5 h-5 text-dark-olive/50" /></div>}
              <div className="min-w-0 flex-1">
                <div className="font-semibold text-[14px] truncate">{c.give_label || c.title}</div>
                {showProg ? (
                  <div className="mt-1">
                    <div className="h-1.5 rounded-full bg-ink/10 overflow-hidden"><div className="h-full bg-dark-olive rounded-full" style={{ width: `${pct}%` }} /></div>
                    <div className="text-[11px] text-ink/55 mt-0.5">{money(c.raised_cents)} raised · {c.gift_count} gifts</div>
                  </div>
                ) : <div className="text-[12px] text-ink/55 truncate">{oneLine(c.story) || "Support Rosemoor"}</div>}
              </div>
              <button data-testid={`ways-give-${c.campaign_id}`} onClick={() => setGive(c)} className="shrink-0 bg-maroon text-cream rounded-lg px-3 py-2 min-h-[40px] text-[13px] font-semibold">Give</button>
            </div>
          );
        })}
      </div>
      {give && <GiveModal campaign={give} prefill={prefill} onClose={() => setGive(null)} />}
    </div>
  );
}
